// bikmo Table Block -------------------------------------------------------------
const updateCardRows = () => {
    var table_rows = {};

    if (window.matchMedia("screen and (min-width: 1200px)").matches) {

        // console.log("MIN-WIDTH CHECK");

        jQuery(".bikmo-quote-blocks-head__benefits .bikmo-quote-block__benefits__item").each(function (index, el) {
            table_rows["row_" + (index + 1)] = $(el).outerHeight();
        });

        $(".bikmo-quote-block__cards .bikmo-quote-block__card").each(function (index, el) {
            for (var r in table_rows) {
                $(el).find(".bikmo-quote-block__card__benefits ." + r).css("height", table_rows[r]);
            }
        });
    }
};

// ------------------ Tab navigation for tablet and below ------------------------
$(".bikmo-quote-block__nav__item").on("click", function () {
    $(this)
        .parent()
        .find(".bikmo-quote-block__nav__item")
        .removeClass("bikmo-quote-block__nav__item--selected");
    $(this)
        .addClass("bikmo-quote-block__nav__item--selected");

    var nextTab = $(this).data("tab");
    $(this)
        .closest(".bikmo-quote-block__body")
        .find(".bikmo-quote-block__card")
        .removeClass("bikmo-quote-block__card--active");
    $(this)
        .closest(".bikmo-quote-block__body")
        .find(".bikmo-quote-block__card--" + nextTab)
        .addClass("bikmo-quote-block__card--active");
});

// ------------------ benefits Show more button -------------------------------------
$(".bikmo-quote-block__load-more").on("click", function () {
    var moreText = $(this).data("more");
    var lessText = $(this).data("less");
    if ($(this).hasClass("less")) {
        $(this)
            .removeClass("less")
            .closest(".bikmo-quote-block__cards")
            .find(".bikmo-quote-block__benefits--hidden")
            .stop()
            .slideUp("400", () => {
                $(".bikmo-quote-block__load-more").text(moreText);
            });
    } else {
        $(this)
            .addClass("less")
            .closest(".bikmo-quote-block__cards")
            .find(".bikmo-quote-block__benefits--hidden")
            .stop()
            .slideDown("400", () => {
                $(".bikmo-quote-block__load-more").text(lessText);
                // updateCardRows();
            });
    }
});

